import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  useMessageSuccess,
  useMessageError,
} from "../../../../hooks/message.hook";
import { Formik, Form, Field } from "formik";
import { placeOrderNoAuth } from "../../../../http/ordersAPI";
import schema from "./schema";
import styles from "./QuickOrder.module.scss";
import { Button } from "react-bootstrap";
import CustomerDataInputs from "../../CustomerDataInputs/CustomerDataInputs";
import DeliveryDataInputs from "../../DeliveryDataInputs/DeliveryDataInputs";
import PaymentDataInputs from "../../PaymentDataInputs/PaymentDataInputs";
import { getUserIsLoadingSelector } from "../../../../store/user/selectors";
import {
  cartTotalPriceAction,
  saveCartAction,
  saveLocalCartAction,
} from "../../../../store/cart/actions";
import { getLocalCartSelector } from "../../../../store/cart/selectors";

const QuickOrder = () => {
  const [messageServer, setMessageServer] = useState(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [commentAvailable, setCommentAvailable] = useState(false);
  const customerLoading = useSelector(getUserIsLoadingSelector);
  const messageSuccess = useMessageSuccess();
  const messageError = useMessageError();
  const [products, setProducts] = useState([]);
  const localCart = useSelector(getLocalCartSelector);
  const touchedRef = useRef(false);

  useEffect(() => {
    if (Array.isArray(localCart) && localCart.length) {
      setProducts(localCart);
    } else {
      navigate("/");
    }
  }, [localCart, navigate]);

  return (
    <Formik
      initialValues={{
        firstName: "",
        lastName: "",
        phone: "+380",
        email: "",
        region: null,
        city: null,
        delivery: { value: "Нова пошта", label: "Нова пошта" },
        address: null,
        paymentMethod: "MonoPay",
        monoPartsCount: "3",
        comment: "",
      }}
      validationSchema={schema}
      onSubmit={(values, { setSubmitting }) => {
        // if (values.paymentMethod === "MonoCredit") {
        //   messageError(
        //     "Оплата частинами monobank буде доступна після активації магазину банком."
        //   );

        //   setSubmitting(false);
        //   return;
        // }
        const deliveryAddress = {
          delivery: values.delivery?.label || "",
          region: values.region?.label || "",
          city: values.city?.label || "",
          address: values.address?.label || "",
        };

        const ordersValue = {
          ...values,
          delivery: values.delivery?.label || "",
        };

        placeOrderNoAuth({ ...ordersValue, deliveryAddress, products })
          .then((res) => {
            if (res.status === 200 || res.status === 201) {
              const pageUrl = res?.data?.data?.pageUrl;

              if (pageUrl) {
                messageSuccess("Замовлення створено. Переходимо до оплати monobank.");
                window.location.assign(pageUrl);
                return;
              }

              messageSuccess("Замовлення успішно оформлене!");
              localStorage.setItem("cart", JSON.stringify([]));
              dispatch(cartTotalPriceAction(0));
              dispatch(saveCartAction([]));
              dispatch(saveLocalCartAction([]));
              navigate("orderAccepted");
            }
          })
          .catch((err) => {
            console.log('error', err);
            const apiMsg =
              err?.response?.data?.message ||
              (err?.response?.data ? Object.values(err.response.data).join(" ") : null);
            const errorMessage = err?.data;
            setMessageServer(<span>{errorMessage}</span>);
            messageError(errorMessage);
          })
          .finally(() => {
            setSubmitting(false);
          });
      }}
    >
      {(formik) => {
        const onTouchStartSubmit = (e) => {
          touchedRef.current = true;
          e.preventDefault();
          formik.submitForm();
        };

        const onClickSubmit = () => {
          if (touchedRef.current) {
            touchedRef.current = false;
            return;
          }
          // нативний сабміт через type="submit"
        };

        return (
          <Form noValidate>
            <div className={styles.tabContainer}>
              <CustomerDataInputs formik={formik} />
              <h3 className="checkout__title">Доставка</h3>
              <DeliveryDataInputs />
              <hr />
              <h3 className="checkout__title">Оплата</h3>
              <PaymentDataInputs products={products}/>

              <hr />
              <div className={styles.addComment}>
                {!commentAvailable && (
                  <span
                    role="button"
                    className={styles.comment}
                    id="commentInvolver"
                    onClick={() => setCommentAvailable(true)}
                  >
                    Додати коментарій
                  </span>
                )}
                {commentAvailable && (
                  <div className={styles.textareaContainer}>
                    <label className={styles.label}>Коментарій</label>
                    <Field
                      as="textarea"
                      className={styles.textarea}
                      name="comment"
                      placeholder="Коментарій"
                      rows={5}
                    />
                  </div>
                )}
              </div>

              <Button
                variant="dark"
                type="submit"
                disabled={!Array.isArray(products) || products.length === 0 || formik.isSubmitting }
                onTouchStart={onTouchStartSubmit}
                onClick={onClickSubmit}
              >
                {formik.isSubmitting ? "Оформлюємо…" : "Оформити замовлення"}
              </Button>
            </div>
          </Form>
        );
      }}
    </Formik>
  );
};

export default QuickOrder;
